import { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { format } from "date-fns";
import { GET_LISTDATA } from "../../actions";
import { apiUrl, adminlimit } from "../Settings/Config";
import {
  showContaimerLoader,
  userID,
  encodeValue,
  showPriceValue,
  checkPermission,
} from "../Settings/Settings";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Pagenation from "../Layout/Pagenation";
var module = "purchaseorder/";
var moduleName = "Purchase Order";
class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userID: userID(),
      loading: true,
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      name: "",
      status: "",
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }

  componentDidMount() {
    this.loadList(1);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.listdata !== this.state.listdata) {
      this.setState({
        listdata: nextProps.listdata,
        loading: false,
        totalRecords: nextProps.totalRecords,
        totalPage: nextProps.totalPages,
      });
    }
  }
  searchList() {
    this.setState({ loading: true }, function () {
      this.loadList(1);
    });
  }
  resetSearch() {
    this.setState(
      {
        loading: true,
        name: "",
        category: "",
        status: "",
      },
      function () {
        this.loadList(1);
      }
    );
  }
  loadList(offset) {
    var addParams = "";
    if (this.state.name !== "") {
      addParams += "&name=" + this.state.name;
    }
    if (
      this.state.status !== null &&
      Object.keys(this.state.status).length > 0
    ) {
      addParams += "&status=" + this.state.status.value;
    }
    var params = {
      params:
        "limit=" +
        adminlimit +
        "&offset=" +
        offset +
        "&userID=" +
        this.state.userID +
        addParams,
      url: apiUrl + module + "list",
    };
    this.props.getListData(params);
  }
  edit(editID) {
    this.props.history.push({
      pathname: "/" + module + "edit",
      state: { editID: encodeValue(editID) },
    });
  }
  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
          loading: true,
          currentPage: value,
        },
        function () {
          this.loadList(value);
        }
      );
    }
  };
  handleChangeText(event) {
    var name = event.target.name;
    var value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }


  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage="purchaseorder" />
            <ToastContainer />
            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid">
                  <div className="page-header">
                    <h1 className="page-title">{moduleName}</h1>
                    {checkPermission("purchaseorder", "add") === true && (
                      <div>
                        <ol className="breadcrumb">
                          <li className="breadcrumb-item">
                            <Link to={"/purchaseorder/create"}>
                              <button
                                className="btn btn-sm btn-primary badge"
                                type="button"
                              >
                                <i className="fa fa-plus"></i> Create New Purchase Order
                              </button>
                            </Link>
                          </li>
                        </ol>
                      </div>
                    )}
                  </div>
                  <div className="row">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        <div className="card-body">
                          <div className="form-row">
                            <div className="col-md-3">
                              <input
                                type="text"
                                className="form-control"
                                placeholder={"Search " + moduleName}
                                name="name"
                                onChange={this.handleChangeText}
                                value={this.state.name}
                              />
                            </div>
                            <div className="col-md-3">
                              <a
                                href={() => false}
                                className="btn btn-primary"
                                onClick={this.searchList.bind(this)}
                              >
                                Search
                              </a>
                              <a
                                href={() => false}
                                className="btn btn-secondary offset-1"
                                onClick={this.resetSearch.bind(this)}
                              >
                                Reload
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-xl-12">
                      <div className="card">
                        {this.state.loading ? (
                          showContaimerLoader()
                        ) : (
                          <div>
                            {parseInt(this.state.totalPage) > 0 && (
                              <div className="card-header">
                                <h3 className="card-title">
                                  <b>{this.state.currentPage}</b> -{" "}
                                  <b> {this.state.totalPage}</b> of{" "}
                                  <b> {this.state.totalPage} </b>
                                  {moduleName}
                                </h3>
                              </div>
                            )}
                            <div className="card-body">
                              <div className="table-responsive">
                                <table className="table text-nowrap text-md-nowrap mb-0">
                                  <thead>
                                    <tr>
                                      <th></th>
                                      <th>Voucher No.</th>
                                      <th>Date</th>
                                      <th>Purchase Amount</th>
                                      <th>GST Amount</th>
                                      <th>Total Purchase Amount</th>
                                      <th>Vendor Name</th>
                                      <th>Vendor Person</th>
                                      <th>Mobile </th>
                                      <th>Email</th>
                                      <th>Address</th>
                                      <th>Mode/Terms of Payment</th>
                                      <th>Reference No.</th>
                                      <th>Other References</th>
                                      <th>Dispatched through</th>
                                      <th>Destination</th>
                                      <th>Terms of Delivery</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {this.state.listdata.length > 0 ? (
                                      this.state.listdata.map((item, index) => {
                                        return (
                                          <tr
                                            key={index}
                                          >
                                            <td>
                                              <a
                                                className="nav-link dropdown-toggle"
                                                data-bs-toggle="dropdown"
                                                href="/"
                                                role="button"
                                                aria-expanded="false"
                                              >
                                                Action
                                              </a>
                                              <ul className="dropdown-menu">
                                                <li>
                                                  <Link
                                                    className="dropdown-item"
                                                    to={`/purchaseorder/invoice/${encodeValue(item.purchaseID)}`}
                                                    target="_blank"
                                                  >
                                                    Print Purchase order
                                                  </Link>
                                                </li>
                                              </ul>
                                            </td>
                                            <td>{item.purchaseVoucherNumber}</td>
                                            <td>
                                              {item.purchaseDate !== "" &&
                                                              item.purchaseDate !== "0000-00-00"
                                                                ? format(new Date(item.purchaseDate), "dd MMM yyyy")
                                                                : ""}
                                            </td>                                              
                                            <td>
                                              {showPriceValue(item.purchaseSubtotal)}
                                            </td>
                                            <td>
                                              {showPriceValue(item.purchaseGSTAmount)}
                                            </td>
                                            <td>
                                              {showPriceValue(item.purchaseAmount)}
                                            </td>
                                            <td>{item.vendorName}</td>
                                            <td>
                                              {item.vendorContactPerson}
                                            </td>
                                            <td>{item.vendorPhone}</td>
                                            <td>{item.vendorEmail}</td>
                                            <td>
                                              {item.vendorAddress}
                                            </td>
                                            <td>
                                              {item.modeofPayment}
                                            </td>
                                            <td>
                                              {item.purchaseReferenceNumber}
                                            </td>
                                            <td>
                                              {item.purchaseOtherReferences}
                                            </td>
                                            <td>
                                              {item.purchaseDispatchedThrough}
                                            </td>
                                            <td>
                                              {item.purchaseDestination}
                                            </td>
                                            <td>
                                              {item.purchaseTermsofDelivery}
                                            </td>
                                          </tr>
                                        );
                                      })
                                    ) : (
                                      <tr>
                                        <td
                                          className="text-center"
                                          colSpan={12}
                                        >
                                          No {moduleName} Found
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                              <Pagenation
                                params={{
                                  totalRecords: this.state.totalRecords,
                                  totalPage: this.state.totalPage,
                                  currentPage: this.state.currentPage,
                                }}
                                sateValChange={this.sateValChange}
                              />                              
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  var listdata = [];
  var totalPages = 0;
  var totalRecords = 0;
  if (Object.keys(state.listdata).length > 0) {
    if (state.listdata[0].status === "ok") {
      listdata = state.listdata[0].result;
      totalPages = state.listdata[0].totalPages;
      totalRecords = state.listdata[0].totalRecords;
    }
  }
  return {
    listdata: listdata,
    totalPages: totalPages,
    totalRecords: totalRecords,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListData: (datas) => {
      dispatch({ type: GET_LISTDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(List);
